import { connect } from 'react-redux';

import WaitingPage from '../components/WaitingPage';
import { setData } from '../redux/incomingData/actions';
import { startRequest } from '../redux/saveEmail/actions';

@connect(
  function ({ app: { user, incomingData, saveEmail } }) {
    return {
      user,
      incomingData,
      userEmail: saveEmail,
    };
  },
  function (dispatch) {
    return {
      saveEmail: (email) => dispatch(startRequest(email)),
      setEmail: (email) => dispatch(setData({ email: email })),
    };
  },
)
export default class WaitingPageContainer extends WaitingPage {}
